import { patch } from '../api';

const patchCandidateRefreshTriggers = (public_profile_id) =>
  patch(`/public_profiles/${public_profile_id}/refresh`);

export default patchCandidateRefreshTriggers;
